import { render, staticRenderFns } from "./_NestedTask.vue?vue&type=template&id=46c373e8&scoped=true&"
import script from "./_NestedTask.vue?vue&type=script&lang=js&"
export * from "./_NestedTask.vue?vue&type=script&lang=js&"
import style0 from "./_NestedTask.vue?vue&type=style&index=0&id=46c373e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c373e8",
  null
  
)

export default component.exports